import { Base } from "./Base";

export interface User extends Base {
  userCode: string;
  userPwd: string;
  userName: string;
  type: number;
  enable: boolean;
  hospitalId: number;
  hospitalName: string;
  schoolId: number;
  schoolName: string;
  add: boolean;
  update: boolean;
  delete: boolean;
  check: boolean;
  report: boolean;
  user: boolean;
  data: boolean;
  count: boolean;
}

export const initUser = {
  id: -1,
  key: -1,
  userCode: "",
  userPwd: "",
  userName: "",
  type: -1,
  enable: true,
  hospitalId: -1,
  hospitalName: "",
  schoolId: -1,
  schoolName: "",
  add: false,
  update: false,
  delete: false,
  check: false,
  report: false,
  user: false,
  data: false,
  count: false,
};
